<template>
    <div class="yl-tooltip">
        <span class="yl-tooltip__trigger" ref="trigger" >
          <slot></slot>
        </span>
        <div class="yl-tooltip__popper yl-tooltip--top"  v-if="show && content" ref="popover" >
            <div class="yl-tooltip__arrow"></div>
            <div class="yl-tooltip__content">
                <div v-text="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import PopoverMixin from './popover'
    export default {
        name: 'YlTooltip',
        mixins: [PopoverMixin],
        props: {
            trigger: {
                type: String,
                default: 'hover'
            },
            transition: {
                type: String,
                default: 'fade'
            }
        }
    }
</script>
<style>
    .yl-tooltip {
        display: inline-block;
    }
    .yl-tooltip__trigger{
        display: inline-block;
        position: relative;
    }
    .yl-tooltip--top{
        padding: 4px 0;
        margin-top: -2px;
    }
    .yl-tooltip__popper {
        position: absolute;
        z-index: 1020;
    }
    .yl-tooltip__arrow{
        position: absolute;
        display: block;
        left: 50%;
        bottom: -4px;
        width:0;
        height:0;
        border-left: solid 10px transparent;
        border-right: solid 10px transparent;
        border-top: solid 8px #ff9d33;
    }
    .yl-tooltip__content{
        padding: 13px 11px;
        max-width: 400px;
        font-size: 24px;
        line-height: normal;
        word-wrap: break-word;
        text-size-adjust:100%;
        color: #333333;
        background-color: #fff7ee;
        border-radius: 6px;
        border: solid .1rem #ff9d33;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tip/Tip.vue